import { Permission } from '../permissions';
import { Roles } from '../roles';
import { ConstructerRolePermissions } from './constructer';
import { OwnerRolePermissions } from './owner';
import { SalesmanRolePermissions } from './salesman';
import { SuperAdminRolePermissions } from './super-admin';

export const RolePermissions = {
  [Roles.SuperAdmin]: SuperAdminRolePermissions,
  [Roles.Owner]: OwnerRolePermissions,
  [Roles.Salesman]: SalesmanRolePermissions,
  [Roles.Constructer]: ConstructerRolePermissions,
} satisfies Record<string, Permission[]>;
